var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueManPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 9.501v1.394A4.001 4.001 0 002 14.667l-1.333-.001a5.333 5.333 0 016.666-5.165zM6 8.667c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-1.334A2.666 2.666 0 106 2a2.666 2.666 0 100 5.333zm4 4v-2h1.333v2h2v1.334h-2v2H10v-2H8v-1.334h2z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/blue-man-plus.svg";
export { SvgBlueManPlus as ReactComponent };